import { ServiceConnectionRefModel } from '../FlowDesigner/Models/ServiceConnectionModel';
import ServiceConnectionDialog from './ServiceConnectionDialog';

type CreateServiceConnectionDialogProps = {
	open: boolean;
	setOpen: (open: boolean) => void;
	onSuccess?: (value: ServiceConnectionRefModel) => void;
};

export default function CreateServiceConnectionDialog({ open, setOpen, onSuccess }: CreateServiceConnectionDialogProps) {
	return <ServiceConnectionDialog open={open} setOpen={setOpen} onSuccess={onSuccess} mode="create" />;
}
